import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logoImg from '../../assets/images/resources/logo-2.png';
import heroImg from '../../assets/images/backgrounds/my-tickets-auth-bg.jpg';
import {
  getBuyerToken,
  requestBuyerMagicLink,
} from '../../services/buyerTicketsApi';
import './MesTickets.css';

const CheckEmailModal = ({ email, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div className="mt-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="mt-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mt-check-email-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="mt-modal__close"
          aria-label="Fermer"
          onClick={onClose}
        >
          ×
        </button>
        <h2 id="mt-check-email-title" className="mt-modal__title">
          Vérifiez votre boîte Email
        </h2>
        <p className="mt-modal__text">
          Le lien de connexion à votre espace personnel a été envoyé à{' '}
          <strong>{email}</strong>
        </p>
        <p className="mt-modal__expiry">
          <i className="far fa-clock" aria-hidden="true" />
          <span>Pour votre sécurité, le lien expire dans 20 minutes.</span>
        </p>
      </div>
    </div>
  );
};

const MesTicketsRequest = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sentEmail, setSentEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (getBuyerToken()) {
      navigate('/mes-tickets/liste', { replace: true });
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = email.trim().toLowerCase();
    if (!trimmed || !trimmed.includes('@')) {
      setError('Veuillez saisir une adresse email valide.');
      return;
    }
    setLoading(true);
    try {
      await requestBuyerMagicLink(trimmed);
      setSentEmail(trimmed);
      setShowModal(true);
    } catch (err) {
      setError(
        err?.message ||
          'Impossible d’envoyer le lien pour le moment. Réessayez plus tard.',
      );
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => setShowModal(false);

  return (
    <div className="mt-login">
      <div className="mt-login__form-pane">
        <div className="mt-login__form-inner">
          <Link to="/" className="mt-login__logo" aria-label="Mboapass — Accueil">
            <img src={logoImg} alt="Mboapass" />
          </Link>

          <h1 className="mt-login__heading">
            Quel email avez-vous utilisé pour acheter vos billets&nbsp;?
          </h1>

          <form className="mt-login__form" onSubmit={onSubmit} noValidate>
            <label className="mt-login__label" htmlFor="buyer-email">
              
            </label>
            <input
              id="buyer-email"
              className={`mt-login__input${error ? ' mt-login__input--error' : ''}`}
              type="email"
              autoComplete="email"
              value={email}
              onChange={(ev) => {
                setEmail(ev.target.value);
                if (error) setError('');
              }}
              placeholder="Adresse email"
              disabled={loading}
              required
            />
            {error ? (
              <p className="mt-login__error" role="alert">
                {error}
              </p>
            ) : null}
            <button
              type="submit"
              className="mt-login__submit"
              disabled={loading}
            >
              {loading ? 'Envoi…' : 'Continuer'}
            </button>
          </form>

          <Link to="/" className="mt-login__back">
            Retour
          </Link>
        </div>
      </div>

      <aside
        className="mt-login__visual"
        style={{ backgroundImage: `url(${heroImg})` }}
        aria-hidden="true"
      >
        <div className="mt-login__visual-overlay" />
        {/* <p className="mt-login__visual-caption">Mboapass — Vos événements</p> */}
      </aside>

      {showModal && sentEmail ? (
        <CheckEmailModal email={sentEmail} onClose={closeModal} />
      ) : null}
    </div>
  );
};

export default MesTicketsRequest;
